import React, { forwardRef } from "react";
import { Modal, Table } from "antd";
import { LeaveScreenItem } from "../../../../../../service/exam";
import { ColumnProps } from "antd/es/table";
import { ModalProps } from "antd/es/modal";

interface DataModalInstance {
    setPayload: (payload: any) => void;
}
interface DataModalProps extends ModalProps {
    data: LeaveScreenItem[];
}

const ShiftModal = forwardRef<DataModalInstance, DataModalProps>(
    ({ data, ...props }, ref) => {
        const columns: ColumnProps<LeaveScreenItem>[] = [
            { title: "时间", dataIndex: "time" },
            { title: "说明", dataIndex: "leaveName" }
        ];

        return (
            <Modal title="切屏记录" footer={false} {...props}>
                <Table
                    rowKey="time"
                    columns={columns}
                    dataSource={data}
                    pagination={false}
                    scroll={{ y: 400 }}
                />
            </Modal>
        );
    }
);

export default ShiftModal;
